import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl" }, " Všetky prílohy podľa typu ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AttachmentList = _resolveComponent("AttachmentList")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!

  return (_openBlock(), _createBlock(_component_PrimevueCard, { class: "w-full mt-2" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.attTypes, (attType) => {
        return (_openBlock(), _createBlock(_component_Fieldset, {
          key: attType.id,
          legend: attType.name,
          toggleable: "",
          collapsed: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AttachmentList, {
              internal: true,
              messageId: this.$props.orderId,
              attTypeId: attType.id
            }, null, 8, ["messageId", "attTypeId"]),
            ($data.store.user.department.id != 1)
              ? (_openBlock(), _createBlock(_component_AttachmentList, {
                  key: 0,
                  internal: false,
                  messageId: this.$props.orderId,
                  attTypeId: attType.id
                }, null, 8, ["messageId", "attTypeId"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["legend"]))
      }), 128))
    ]),
    _: 1
  }))
}